import React from "react";
import {FormattedMessage, FormattedTime} from "react-intl";
import {REQUESTED_TIME_ASAP, REQUESTED_TIME_PRESENT} from "@/data/entities/order";

type WithRequestedTime = {
    requestedTime: string,
};

const getRequestedDate = (order: WithRequestedTime): Date | null => {
    if (order.requestedTime === REQUESTED_TIME_ASAP || order.requestedTime === REQUESTED_TIME_PRESENT)
        return null;

    const date = new Date(order.requestedTime);
    return isNaN(date.getTime()) ? null : date;
};

type Props = {
    order: WithRequestedTime,
};

const RequestedTime = ({order}: Props) => {
    // The customer already waits in the restaurant
    if (order.requestedTime === REQUESTED_TIME_PRESENT) {
        return <FormattedMessage id={"pos.order.present"}/>;
    }

    const requested = getRequestedDate(order);

    if (requested === null) {
        return <FormattedMessage id={"pos.order.asap"}/>;
    }

    return (
        <FormattedTime
            value={requested}
            hour={"2-digit"}
            minute={"2-digit"}
            hourCycle={"h23"}
        />
    );
};

export default RequestedTime;